export { TestimonialMemo } from './Testimonial';
